import * as React from 'react'
import { FC, useContext } from 'react'
import { TitleContext } from '../TitleDetails'
import Section from '../fragments/Section'

import './WatchNow.scss'

const WatchNow: FC = () => {
    const context = useContext(TitleContext)

    return (
        <Section id="watch-now" className="WatchNow" style={{ minHeight: context.sectionMinHeight }}>
            <a href={context.titleData.watchNowURL} target="_blank">
                <img src={context.titleData.watchNowImage} alt="watch now" />
                <div className="WatchNow__overlay">
                    <span className="WatchNow__clickHere">Click Here to Login</span>
                </div>
            </a>
        </Section>
    )
}

export default WatchNow
